import { render, staticRenderFns } from "./LegalModal.vue?vue&type=template&id=294ce812&"
import script from "./LegalModal.vue?vue&type=script&lang=js&"
export * from "./LegalModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('294ce812')) {
      api.createRecord('294ce812', component.options)
    } else {
      api.reload('294ce812', component.options)
    }
    module.hot.accept("./LegalModal.vue?vue&type=template&id=294ce812&", function () {
      api.rerender('294ce812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/modals/LegalModal.vue"
export default component.exports